import {
	UPLOAD_RESOURCE_IMAGES,
	GET_RESOURCE_IMAGES,
	DOWNLOAD_RESOURCE_IMAGE,
	CLEAR_RESOURCE_IMAGES,
	DELETE_RESOURCE_IMAGES
} from "../constants/action-types";

import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();


/* 
  
*/
export const getResourceImages = (resourceType, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/resourceImages?ResourceType=${resourceType}`, {
		method: "get"
	}).then(res => {
		const data = res.data;

		dispatch({
			type: GET_RESOURCE_IMAGES,
			payload: data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/* 
  
*/
export const uploadResourceImages = (files, resourceType, callback) => dispatch => {
	const formData = new FormData();
	files.forEach(file => {
		formData.append(file.fileName, file)
	});
	adalApiFetch(Axios, `${API_CONFIG.URL}/resourceImages/upload?ResourceType=${resourceType}`, {
		method: "post",
		data: formData,
		headers: { 'Content-Type': 'multipart/form-data' }
	}).then(res => {
		const data = res.data;
		dispatch({
			type: UPLOAD_RESOURCE_IMAGES,
			payload: data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

export const downloadResourceImageBlob = (fileId, resourceType, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/resourceImages/download?Path=${resourceType}/${fileId}&isWebAdmin=true`, {
		method: "get",
	})
		.then(res => {
			const imageUrl = res.data

			callback(imageUrl)
		}).catch((error) => {
			console.log(`Exception Occurred: ${error.message}`);
			callback(null);
		})
}

export const deleteResourceImages = (data, resourceType, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/resourceImages/delete?ResourceType=${resourceType}`, {
		method: "delete",
		data: data
	})
		.then(res => {
			// const blob = res.data

			dispatch({
				type: DELETE_RESOURCE_IMAGES,
				payload: null
			});

			callback(true)
		}).catch((error) => {
			console.log(`Exception Occurred: ${error.message}`);
			callback(false);
		})
}


export const clearResourceImages = (callback) => dispatch => {
	dispatch({
		type: CLEAR_RESOURCE_IMAGES,
		payload: null
	});

	callback(true)
}